<template>  
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Attribute') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.GroupCode') }} *</label>
              <input v-model="state.groupCode" type="text" class="form-control form-control-default" :placeholder="$t('settings.GroupCode')">
              <span v-if="v$.groupCode.$error" class="text-sm text-danger">
                  {{ v$.groupCode.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.Group') }} *</label>
              <input v-model="state.group" type="text" class="form-control form-control-default" :placeholder="$t('settings.Group')">
              <span v-if="v$.group.$error" class="text-sm text-danger">
                  {{ v$.group.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.AttributeCode') }}</label>
              <input v-model="state.attributeCode" type="text" class="form-control form-control-default" :placeholder="$t('settings.AttributeCode')">              
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.Attribute') }}</label>
              <input v-model="state.attribute1" type="text" class="form-control form-control-default" :placeholder="$t('settings.Attribute')">            
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.DataType') }}</label>  
              <select id="datatype" v-model="state.datatype" class="form-control form-control-default">
                  <option value="">{{ $t('settings.Select_datatype') }}</option>
                  <option v-for="item in state.dataTypes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.ReferenceType') }}</label>  
              <select id="referenceTypeId" v-model="state.referenceTypeId" class="form-control form-control-default">
                  <option value="">{{ $t('settings.Select_referencetype') }}</option>
                  <option v-for="item in state.referenceTypes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>          
        </div>
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.Required') }}</label>
              <div class="d-block mt-1">
                <material-switch v-model="state.required" id="required" name="required" />
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('settings.SortOrder') }}</label>
              <input v-model="state.sortorder" type="text" class="form-control form-control-default" :placeholder="$t('settings.SortOrder')">
              <span v-if="v$.sortorder.$error" class="text-sm text-danger">
                {{ v$.sortorder.$errors[0].$message }}
              </span>
            </div>
          </div>          
        </div>      
        <div class="col-12 col-sm-12 mt-6">                                
          <input type="hidden" v-model="state.id" class="form-control">          
          <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
          <button v-on:click="updateAttribute" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>
        </div>        
      </div>
    </div>    
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import * as Choices from "choices.js";  
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  
  export default {
    name: "AttributeDetail",
    setup() {
        const { t } = useI18n()

        const state = reactive ({            
            attribute: [],            
            id: '',
            groupCode: '',
            group: '',
            attributeCode: '',
            attribute1: '',
            datatype: '',
            required: false,
            sortorder: '',
            referenceTypeId: '',
            referenceTypes:[],
            dataTypes:[]
        })
        
        const rules = computed(() => {            
            return {
                groupCode: { required: helpers.withMessage(t('common.Required'), required) },
                group: { required: helpers.withMessage(t('common.Required'), required) },
                sortorder: { integerOnly }                
            }
        })
        
        const integerOnly = helpers.withMessage(
          t('common.Integer_only'),
          value => {
            if (value === '' || value === null || value === undefined) return true; // allow empty
            return /^[0-9]+$/.test(value); // only allow integers
          }
        )

        const v$ = useValidate(rules, state)

        return {
            state,
            v$,            
            choicesReferenceType: null,
            choicesDataType: null,
        }
    },    
    components: { 
      MaterialSwitch,
    },
    data() {
      return {        
        gets: [],
        error: '',        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;            
      await this.fetchAttributeData(this.$route.params.id);         
    },
    methods: { 
      async fetchAllReferenceTypeData() {
          try {
            const response = await axios.get("referencetype/getall"); 
            const result = response.data;

            if (result.success && Array.isArray(result.data)) {
                this.state.referenceTypes = result.data;

                this.$nextTick(() => {
                    this.initializeChoicesDropdown({
                        id: "referenceTypeId",
                        dataList: this.state.referenceTypes,
                        selectedValue: this.state.referenceTypeId,
                        instanceKey: "choicesReferenceType"
                    });
                });
            } else {
                this.$showError('errors.Error_fetching_referencetype');
            }
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      async fetchAllDataTypeData() {
          try {
            const staticData = [
              { id: 'int', name: 'Intiger' },
              { id: 'dec', name: 'Decimal' },
              { id: 'char', name: 'Character' },
              { id: 'mult', name: 'Multiline' },
              { id: 'date', name: 'Date' },
              { id: 'ref', name: 'Reference' }
            ];
            this.state.dataTypes = staticData;

            this.$nextTick(() => {
                this.initializeChoicesDropdown({
                    id: "datatype",
                    dataList: this.state.dataTypes,
                    selectedValue: this.state.datatype,
                    instanceKey: "choicesDataType"
                });
            });            
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
          const element = document.getElementById(id);
          if (!element || element.tagName !== "SELECT") {
              console.error(`Choices: Invalid or missing select element with ID "${id}".`);
              return;
          }

          // Destroy previous instance if it exists
          if (this[instanceKey]) {
              this[instanceKey].destroy();
          }

          // Initialize new Choices instance
          this[instanceKey] = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true,
          });

          // Set selected value if it exists in list
          if (selectedValue) {
              const optionExists = dataList.some(item => item.id === selectedValue);
              this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
          }
      },

      async fetchAttributeData(attributeId) {
        try {            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Attribute/${attributeId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.attribute = this.gets.data;
                this.state.id = this.state.attribute.id;
                this.state.required = this.state.attribute.required;
                this.state.groupCode = this.state.attribute.groupCode;
                this.state.group = this.state.attribute.group;
                this.state.attributeCode = this.state.attribute.attributeCode;
                this.state.attribute1 = this.state.attribute.attribute1;
                this.state.datatype = this.state.attribute.datatype;
                this.state.required = this.state.attribute.required;
                this.state.sortorder = this.state.attribute.sortorder;
                this.state.referenceTypeId = this.state.attribute.referenceTypeId;
                                
                await this.fetchAllReferenceTypeData();
                await this.fetchAllDataTypeData();
                
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },
      async updateAttribute() {   
            try {
                this.$store.commit('setShowLoading', true);

                this.v$.$validate();
                console.log(this.v$.$error);

                if(!this.v$.$error) {

                    const formData = {
                        'id': this.state.id,
                        'groupCode': this.state.groupCode,
                        'group': this.state.group,
                        'attributeCode': this.state.attributeCode,
                        'attribute1': this.state.attribute1,
                        'datatype': this.state.datatype,
                        'referenceTypeId': this.state.referenceTypeId,
                        'sortorder': this.state.sortorder,
                        'required': this.state.required
                    };
                    const response = await axios.put('Attribute/update', formData);
                    this.gets = response.data;

                    if (this.gets.success) {
                      this.$showSuccess('errors.Success_attribute_updated_successfully');
                      this.$router.push('/settings');
                    } else {
                        this.$showError('errors.Contact_system_admin');
                    }
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }                        
            this.$store.commit('setShowLoading', false);
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>